














import { Component, Prop, Vue, Inject } from "vue-property-decorator";
import AppVue from "@/App.vue";
import { IResult } from "@/calculationManager";

@Component
export default class Preview extends Vue {

    @Inject("app")
    app!: AppVue;

    previewData: Array<Record<string, any>> = [];

    mounted() {
        this.calculate();
    }

    async calculate() {
        try {
            this.previewData = await this.app.calculator.run(20);
        } catch (err) {
            this.$emit("error", err);
        }
    }

    get headers() {
        return this.previewData.length > 0 ? Object.keys(this.previewData[0]) : [];
    }

    get rows() {
        return this.previewData.length > 0 ? this.previewData.map((d) => Object.values(d)) : [];
    }

    get isEmpty() {
        return !this.previewData ||
            this.previewData.length === 0 ||
            this.previewData.every((d) => Object.entries(d).length === 0);
    }

}
